import React from 'react'
import FacebookPlanDlg from '../components/FacebookPlanDlg'
import '../assets/scss/index.scss'
import { Box, Typography, Grid, useMediaQuery } from '@mui/material'
import FacebookPlan from '../components/FacebookPlan'
import { useTheme } from '@mui/material/styles'

function createData (
  text: string
) {
  return { text }
}

const liteDetails = [
  createData('General ad in your target location, like a buyer or seller for real estate agents or a home purchase ad for loan officers to drive active leads for your business.')
]

const boostDetails = [
  createData('Lead magnet carousel listing ads.'),
  createData('Customize ads with your logo, business name and personal headshot.'),
  createData('Upgrade your evergreen ads to carousels with up to 3 graphics to highlight more features of your business.')
]

const eliteDetails = [
  createData('Custom graphics or animated ads with full rights to use to promote your business on social media, emails, etc.'),
  createData('Branded carousel ads with up to 5 images to highlight more aspects of your listing or features of your business.'),
  createData('We can feature any message, event, special requests, promotion, etc.'),
  createData('Option to add website retargeting to boost performance and convert site visitors into leads.')
]

const FacebookAds: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))

  const [openEditDialog, setOpenEditDialog] = React.useState(false)
  const handleOpenEditDialog = () => { setOpenEditDialog(true) }
  const handleCloseEditDialog = () => { setOpenEditDialog(false) }

  return (
    <Box sx={{
      background: 'linear-gradient(rgba(26, 191, 251, 0.25), rgba(29, 119, 242, 0.25))',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      px: isMobile ? 2 : 3,
      py: 2
    }}>
      <Typography variant='h2' align='center' sx={{ pt: 2, pb: isMobile ? 2 : 3, mx: 2, color: theme.palette.grey[40] }}>
        Choose Your Facebook Advertising Plan
      </Typography>
      <Grid
        container
        maxWidth='1089px'
        spacing={{ xs: 2, sm: 2, md: 2, lg: 3 }}
      >
        <Grid item xs={12} sm={12} md={6} lg ={4}>
          <FacebookPlan name='Lite' impressions={2000} price={100} details={liteDetails}
            description='Drive Leads by Promoting Your Business'
          ><></></FacebookPlan>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg ={4}>
          <FacebookPlan name='Boost' impressions={6000} price={300} details={boostDetails}
            description='Drive More Leads with Custom Evergreen + Carousel Listing Ads'
          ><></></FacebookPlan>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg ={4}>
          <FacebookPlan name='Elite' impressions={10000} price={500} details={eliteDetails} handleClick={handleOpenEditDialog}
            description='Supercharge with Animated Ads & Multiple Custom Campaigns'
          ><></></FacebookPlan>
        </Grid>
        </Grid>
      <FacebookPlanDlg name='Set Your Budget' open={openEditDialog} handleClose={handleCloseEditDialog} />
    </Box>
  )
}

export default FacebookAds
